// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  name: 'test',
  features: ['accountCreation'],
  authenticationEnabled: true,
  urls: {
    pricing: '',
    terms: '',
    privacy: '',
    blog: '',
    changelog: '',
    feedback: '',
    help: '',
    roadmap: '',
    newsletter: '',
    prefundBlog: '',
    gaborBlog: '',
    gaborBluesky: '',
    researchSociologicalScience:
      '',
    researchZhangYiling: '',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyC-ZwzR9q6fpARi_7MuA-n8M67JIGyR-5M',
    authDomain: 'prefund-578f4.firebaseapp.com',
    projectId: 'prefund-578f4',
    storageBucket: 'prefund-578f4.firebasestorage.app',
    messagingSenderId: '244062364978',
    appId: '1:244062364978:web:a568348f902fd46ba2e32b',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
